import { Box, Text } from "rebass";
import styled from "styled-components";
import {
  BiSolidUserPlus,
  BiSolidUserCheck,
  BiSolidUserMinus,
} from "react-icons/bi";

interface IFollowButtonProps {
  isFollowing: boolean;
  onFollow: () => void;
  onUnfollow: () => void;
}

export const FollowButton = ({
  isFollowing,
  onFollow,
  onUnfollow,
}: IFollowButtonProps) => {
  if (isFollowing) {
    return (
      <FollowingButton onClick={onUnfollow}>
        <DefaultIcon>
          <BiSolidUserCheck size={20} />
        </DefaultIcon>
        <HoverIcon>
          <BiSolidUserMinus size={20} />
        </HoverIcon>
        <ButtonText>Following</ButtonText>
        <HoverText>Unfollow</HoverText>
      </FollowingButton>
    );
  }

  return (
    <BaseFollowButton onClick={onFollow}>
      <BiSolidUserPlus size={20} />
      Follow
    </BaseFollowButton>
  );
};

const ButtonText = styled(Text)`
  display: block;
`;

const HoverText = styled(Text)`
  display: none;
`;

const DefaultIcon = styled(Box)`
  display: block;
`;

const HoverIcon = styled(Box)`
  display: none;
`;

const BaseFollowButton = styled.button`
  align-items: center;
  background: ${({ theme }) => theme.colors.envy};
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  display: flex;
  font-family: Barlow;
  font-size: 14px;
  font-weight: 500;
  gap: 8px;
  height: 36px;
  justify-content: center;
  min-width: 100px;
  padding: 0 12px;

  &:hover {
    background: ${({ theme }) => theme.colors.darkerEnvy};
  }
`;

const FollowingButton = styled.button`
  align-items: center;
  background: ${({ theme }) => theme.colors.navy50};
  border: none;
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.envy};
  cursor: pointer;
  display: flex;
  font-family: Barlow;
  font-size: 14px;
  font-weight: 500;
  gap: 8px;
  height: 36px;
  justify-content: center;
  min-width: 100px;
  padding: 0 12px;
  position: relative;

  &:hover {
    background: ${({ theme }) => theme.colors.alert};
    color: white;

    ${ButtonText} {
      display: none;
    }

    ${HoverText} {
      display: block;
    }

    ${DefaultIcon} {
      display: none;
    }

    ${HoverIcon} {
      display: block;
    }
  }
`;
